const SET_STATUSES = 'SET_STATUSES';

const setStatuses = statuses => ({
  type: SET_STATUSES,
  payload: {
    statuses
  }
});

export { SET_STATUSES, setStatuses };
